import Tooltip from "@mui/material/Tooltip";
import { useContext, useEffect, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import "../../../../Tooltip/styles/tooltip.css";
import { DashboardContext } from "../../../DashboardContext/DashboardContextProvider";
import NewText from "../Inputs/NewText.jsx";
import RadioField from "../Inputs/RadioField";
import { FormContext } from "../context/FormProvider";
import { scrollToFirstRequiredField } from "../main-helper.js";
import { scopeOfWorkMessage } from "../messages/messages";
import "../styles/form-container.css";
import useSetSlide from "./Hooks/setSlide";
import useInvalidInputs from "./Hooks/useInvalidInputs";
import "./styles/project-type.css";

// Slide 3: Project Type/ Scope of Work
const ProjectType = ({ setSlideStatus, slideState, formStateLoaded }) => {
  const [openScopeTooltip, setOpenScopeTooltip] = useState(false);
  const [disabledInputs, setDisabledInputs] = useState([]);
  const {
    slide3,
    setSlide3,
    setIsLoading,
    requestStatus,
    populateInvalidInputs,
    disabledInputCheck,
  } = useContext(FormContext);

  const { clientId, projectId } = useContext(DashboardContext);

  useEffect(() => {
    scrollToFirstRequiredField(slide3);
  }, []);

  // Update Slide Logic
  const slide3Mutation = useSetSlide(
    clientId,
    projectId,
    3,
    setIsLoading,
    setSlideStatus,
  );

  // Get Invalid Inputs
  const invalidInputsData = useInvalidInputs(
    clientId,
    projectId,
    requestStatus,
  );

  // Populate invalid inputs
  useEffect(() => {
    populateInvalidInputs(
      invalidInputsData,
      disabledInputs,
      setDisabledInputs,
      "3",
    );
  }, [invalidInputsData.data, invalidInputsData.isFetched]);

  return (
    <>
      <div className={"project-type-container"}>
        <RadioField
          idProp="t1"
          label="ADOT"
          state={slide3}
          setState={setSlide3}
          val={slide3.t1}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t1", disabledInputs)}
        />
        <RadioField
          idProp="t2"
          label="Airport"
          state={slide3}
          setState={setSlide3}
          val={slide3.t2}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t2", disabledInputs)}
        />
        <RadioField
          idProp="t3"
          label="Commercial"
          state={slide3}
          setState={setSlide3}
          val={slide3.t3}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t3", disabledInputs)}
        />
        <RadioField
          idProp="t4"
          label="Flood Control"
          state={slide3}
          setState={setSlide3}
          val={slide3.t4}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t4", disabledInputs)}
        />
        <RadioField
          idProp="t5"
          label="Mining Sand Gravel"
          state={slide3}
          setState={setSlide3}
          val={slide3.t5}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t5", disabledInputs)}
        />
        <RadioField
          idProp="t6"
          label="Municipal/Public"
          state={slide3}
          setState={setSlide3}
          val={slide3.t6}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t6", disabledInputs)}
        />
        <RadioField
          idProp="t7"
          label="Pipeline"
          state={slide3}
          setState={setSlide3}
          val={slide3.t7}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t7", disabledInputs)}
        />
        <RadioField
          idProp="t8"
          label="Recreational Area"
          state={slide3}
          setState={setSlide3}
          val={slide3.t8}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t8", disabledInputs)}
        />
        <RadioField
          idProp="t9"
          label="Residence"
          state={slide3}
          setState={setSlide3}
          val={slide3.t9}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t9", disabledInputs)}
        />

        <RadioField
          idProp="t10"
          label="Roads"
          state={slide3}
          setState={setSlide3}
          val={slide3.t10}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t10", disabledInputs)}
        />
        <RadioField
          idProp="t11"
          label="Schools"
          state={slide3}
          setState={setSlide3}
          val={slide3.t11}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t11", disabledInputs)}
        />

        <RadioField
          idProp="t12"
          label="Subdivision"
          state={slide3}
          setState={setSlide3}
          val={slide3.t12}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t12", disabledInputs)}
        />
        <RadioField
          idProp="t13"
          label="Utilities"
          state={slide3}
          setState={setSlide3}
          val={slide3.t13}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("t13", disabledInputs)}
        />
        <RadioField
          idProp="other"
          label="Other"
          state={slide3}
          setState={setSlide3}
          val={slide3.other}
          req={
            !slide3.t1 &&
            !slide3.t2 &&
            !slide3.t3 &&
            !slide3.t4 &&
            !slide3.t5 &&
            !slide3.t6 &&
            !slide3.t7 &&
            !slide3.t8 &&
            !slide3.t9 &&
            !slide3.t10 &&
            !slide3.t11 &&
            !slide3.t12 &&
            !slide3.t13 &&
            !slide3.other
          }
          debouncedSave={slide3Mutation}
          setIsLoading={setIsLoading}
          disabledInput={disabledInputCheck("other", disabledInputs)}
        />
        {slide3.other === true ? (
          <NewText
            idProp="otherText"
            label="Type of Project"
            type="project"
            state={slide3}
            setState={setSlide3}
            val={slide3.otherText}
            req={slide3.other === true && slide3.otherText === ""}
            debouncedSave={slide3Mutation}
            setIsLoading={setIsLoading}
            disabledInput={disabledInputCheck("otherText", disabledInputs)}
          />
        ) : null}
      </div>
      <div className="sow-container">
        <header id="sow-heading-container">
          <h1 className="form-container-heading">Scope of Work</h1>
          <Tooltip
            id="sow-tooltip"
            title={scopeOfWorkMessage}
            placement="right"
            classes={{
              tooltip: "sow-tooltip",
              popper: "sow-popper",
              arrow: "sow-arrow",
            }}
            arrow
          >
            <InfoCircle
              className="sow-info-circ"
              id="sow-info-circ"
              color="white"
              size={20}
              onMouseEnter={() => setOpenScopeTooltip(true)}
              onMouseLeave={() => setOpenScopeTooltip(false)}
            />
          </Tooltip>
        </header>
        <textarea
          className="form-textarea"
          id="sow-textarea"
          placeholder="Site & mass grading, utility infrastructure, etc."
          value={slide3.scopeOfWork}
          onChange={(e) => {
            setSlide3((prevState) => ({
              ...prevState,
              scopeOfWork: e.target.value,
            }));
            setIsLoading(true);
            slide3Mutation.mutate({
              ...slide3,
              scopeOfWork: e.target.value,
            });
          }}
        />
      </div>
    </>
  );
};

export default ProjectType;
